import { render, staticRenderFns } from "./DigitalHumanDashboard.vue?vue&type=template&id=0c6bf7c6&scoped=true"
import script from "./DigitalHumanDashboard.vue?vue&type=script&lang=ts"
export * from "./DigitalHumanDashboard.vue?vue&type=script&lang=ts"
import style0 from "./DigitalHumanDashboard.vue?vue&type=style&index=0&id=0c6bf7c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6bf7c6",
  null
  
)

export default component.exports